import React from "react";
import { Stack } from "@mui/material";
import { Text } from "@imminently/react/ui/core/text";
import { TemplateSelectInputProps, LAYOUT_CONFIG, TemplateSelectVisual } from "./PatientNotesConstants";
import { PatientNotesTemplateInputChips } from "./PatientNotesTemplateInputChips";
import { PatientNotesTemplateInputSelect } from "./PatientNotesTemplateInputSelect";

type TemplateSelectProps = TemplateSelectInputProps;

export const PatientNotesTemplateSelect: React.FC<TemplateSelectProps> = React.memo((p) => {
  const { value, onChange, onTemplateSelect, error, disabled } = p;

  return (
    <Stack
      position="absolute"
      zIndex="1"
      top={LAYOUT_CONFIG.noteTypeTop}
      left="1rem"
      direction="row"
      alignItems="center"
      gap="1rem"
    >
      <Text variant="subtitle1">Template</Text>

      {(() => {
        const TemplateSelectComponent = TemplateSelectVisual === "chips" ? PatientNotesTemplateInputChips : PatientNotesTemplateInputSelect;
        return (
          <TemplateSelectComponent
            value={value}
            onChange={onChange}
            onTemplateSelect={onTemplateSelect}
            error={error}
            disabled={disabled}
          />
        );
      })()}

      {error && (
        <Text color="error" variant="caption">
          {error.message}
        </Text>
      )}
    </Stack>
  );
});

PatientNotesTemplateSelect.displayName = "PatientNotesTemplateSelect";
